import { combineReducers } from 'redux';
import ReducerAPI from './ReducerAPI';
import ReducerLink from './ReducerLink';

export default combineReducers({ ReducerAPI, ReducerLink });